import ShowcaseAnonymizeVisitorTypes from 'store/actionTypes/showcaseAnonymizeVisitor'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {}
}

const showcaseAnonymizeVisitor = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ShowcaseAnonymizeVisitorTypes.GET_ANONYMIZE_VISITOR_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ShowcaseAnonymizeVisitorTypes.UPDATE_FILTER_ANONYMIZE_VISITOR_SUCCESS:
      return { ...state, filter: payload }
    case ShowcaseAnonymizeVisitorTypes.CLEAR_FILTER_ANONYMIZE_VISITOR_SUCCESS:
      return { ...state, filter: initialData.filter }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default showcaseAnonymizeVisitor
